import { SanityModule } from '@data/sanity/queries/types/modules'
import {
  SanityProductFragment,
  SanityProductVariantFragment,
} from '@data/sanity/queries/types/product'
import { SanityCart } from '@data/sanity/queries/types/site'
import { SanityBlogPostWithoutContent } from '@data/sanity/queries/types/blog'
import { Reviews } from '@lib/review'

import Module from './module'

interface ModulesProps {
  modules: SanityModule[] | null
  product?: SanityProductFragment
  posts?: SanityBlogPostWithoutContent[]
  activeVariant?: SanityProductVariantFragment
  onVariantChange?: (variantId: number) => void
  collectionProducts?: SanityProductFragment[]
  featuredProductIds?: number[]
  cartSettings?: SanityCart
  reviews?: Reviews
}

const Modules = ({
  modules,
  reviews,
  product,
  posts,
  activeVariant,
  onVariantChange,
  collectionProducts,
  featuredProductIds,
  cartSettings,
}: ModulesProps) => {
  if (!modules) {
    return null
  }

  return (
    <>
      {modules.map((module) => (
        <Module
          key={module._key}
          module={module}
          cartSettings={cartSettings}
          posts={posts}
          collectionProducts={collectionProducts}
          featuredProductIds={featuredProductIds}
          product={product}
          activeVariant={activeVariant}
          onVariantChange={onVariantChange}
          reviews={reviews}
        />
      ))}
    </>
  )
}

export default Modules
